(function () {
  'use strict';

  angular.module('app').component('resourceList', resourceList());

  function resourceList() {
    return {
      bindings: {
        resources: '=',
        meta: '<',
        totalItems: '=',
        loadingItems: '<',
      },
      controller: ResourceListComponent,
      controllerAs: 'vm',
      templateUrl: './app/ajs/resources/resource-list/resource-list.component.html',
    };
  }

  ResourceListComponent.$inject = [
    'CONFIGURATIONS',
    'UtilService',
    'AbilityService',
    'ResourceService',
    'ResourceAvailabilityService',
  ];

  function ResourceListComponent(
    config,
    UtilService,
    AbilityService,
    ResourceService,
    ResourceAvailabilityService
  ) {
    const vm = this;

    // public properties
    // -----------------------
    vm.UtilService = new UtilService(vm);

    vm.permissions = {
      canShow: AbilityService.can('show_resource_accountadmin'),
      canUpdate: AbilityService.can('update_resource_accountadmin'),
      canDestroy: AbilityService.can('destroy_resource_accountadmin'),
    };

    vm.filterCriteria = ResourceService.getFilterCriteria();
    vm.resourceTypes = config.RESOURCE_TYPES;

    // private properties
    // -----------------------

    // public methods
    // -----------------------
    vm.fetchResult = function () {
      vm.loadingItems = true;
      ResourceService.getResources(vm.filterCriteria).then((data) => {
        vm.resources = data.items;
        vm.meta = data.meta;

        vm.resources.sort((a, b) => (a.resource_contact.name > b.resource_contact.name ? 1 : -1));

        vm.totalItems = vm.meta.totalItems;

        vm.loadingItems = false;

        vm.showActions = false;
      });
    };

    // refresh the data with the default filter criteria
    vm.refresh = function () {
      vm.filterCriteria = ResourceService.getFilterCriteria();
      vm.fetchResult();
    };

    vm.selectPage = function () {
      vm.filterCriteria.offset = (vm.filterCriteria.page - 1) * vm.meta.itemsPerPage;
      vm.fetchResult();
    };

    vm.onSort = function (sortedBy, sortDir) {
      vm.filterCriteria.page = 1;
      vm.filterCriteria.sortDir = sortDir;
      vm.filterCriteria.sortedBy = sortedBy;
      vm.fetchResult();
    };

    vm.changeResourceStatus = function (resource) {
      if (!vm.permissions.canUpdate) return;

      ResourceService.changeResourceStatus(resource);
    };

    vm.deleteResource = function (resource) {
      if (!vm.permissions.canDestroy) return;

      ResourceService.deleteResource(resource, vm.fetchResult);
    };

    vm.openResourceAvailabilityListModal = function (resource) {
      // const successCallback = (resourceObj) => {
      //     console.log('openResourceAvailabilityListModal: ', resourceObj);
      // };

      ResourceAvailabilityService.openResourceAvailabilityListModal(resource); // successCallback
    };

    vm.openResourceCalendarModal = function (resource) {
      ResourceService.openResourceCalendarModal(resource);
    };
  }
})();
